import { Box, Paper, Typography } from '@mui/material'
import useActivationObject from '../providers/ActivationObjectProvider/hooks/useActivationObject'

const Redirect = () => {
    const activationObject = useActivationObject().data
    if (!activationObject || activationObject.wizardStep !== 'Redirect') return <></>

    return (
        <Box maxWidth={625} marginTop='50px'>
            <Paper>
                <Box p={3} textAlign='center'>
                    <Box p={1}>
                        <Typography variant='h4'>AKTIVACE UKONČENA</Typography>
                    </Box>
                    <Box p={1}>
                        <Typography variant='body1' paragraph>
                            {activationObject.message}
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default Redirect
